/* MONDSTEIN by Metagon · mds-explore.js · section mds-explorer ("Sieben Lagen"). Ported from the mock's media/explore/explore.js.
   The layer cut-outs open from a closed duvet when the box scrolls into view, float gently, and on tap or click the chosen
   layer comes forward with a close-up and its text. Layers come from the section's layer blocks as JSON ([data-mx-layers]).
   Picking: for the shipped mock pictures, HIT (60 columns per picture: top and bottom of its opaque part, from the alpha of
   mds-lage-*.webp) finds the layer really under the pointer; a picture the merchant picks counts with its whole box.
   Keyboard: the list buttons, Esc closes, arrow keys step through the layers. Reduced motion: no float, no tweening. */
import { $, $$, boot, claim, onResize, reduce } from '@mds/core';

const HIT = {"lage-huelle-oben":[[0.361,0.427],[0.339,0.435],[0.317,0.441],[0.295,0.446],[0.267,0.455],[0.242,0.463],[0.22,0.474],[0.201,0.488],[0.187,0.501],[0.176,0.512],[0.165,0.523],[0.152,0.537],[0.135,0.551],[0.121,0.567],[0.107,0.587],[0.096,0.603],[0.083,0.623],[0.072,0.639],[0.066,0.658],[0.052,0.675],[0.044,0.691],[0.033,0.708],[0.022,0.727],[0.011,0.744],[0.006,0.763],[0.003,0.782],[0.003,0.804],[0.003,0.826],[0.008,0.846],[0.017,0.868],[0.028,0.884],[0.036,0.901],[0.047,0.92],[0.058,0.942],[0.072,0.964],[0.08,0.989],[0.083,0.997],[0.085,0.997],[0.091,0.978],[0.099,0.942],[0.11,0.909],[0.121,0.879],[0.129,0.846],[0.138,0.815],[0.152,0.785],[0.163,0.758],[0.174,0.73],[0.187,0.705],[0.204,0.678],[0.22,0.653],[0.234,0.628],[0.248,0.603],[0.262,0.581],[0.275,0.559],[0.292,0.537],[0.309,0.518],[0.331,0.501],[0.347,0.488],[0.366,0.477],[0.386,0.466]],"lage-fuellung":[[0.319,0.45],[0.28,0.502],[0.28,0.515],[0.257,0.554],[0.243,0.572],[0.238,0.572],[0.21,0.592],[0.213,0.619],[0.196,0.626],[0.183,0.636],[0.171,0.668],[0.166,0.681],[0.151,0.686],[0.136,0.693],[0.129,0.728],[0.109,0.743],[0.109,0.74],[0.084,0.77],[0.082,0.777],[0.064,0.792],[0.064,0.809],[0.04,0.829],[0.04,0.829],[0.027,0.864],[0.012,0.876],[0.002,0.891],[0.005,0.899],[0.002,0.926],[0.015,0.926],[0.017,0.95],[0.032,0.958],[0.042,0.963],[0.047,0.978],[0.062,0.975],[0.064,0.995],[0.087,0.995],[0.089,0.968],[0.099,0.936],[0.109,0.918],[0.126,0.906],[0.126,0.874],[0.144,0.861],[0.151,0.844],[0.156,0.824],[0.178,0.802],[0.176,0.79],[0.196,0.772],[0.203,0.76],[0.203,0.72],[0.225,0.708],[0.23,0.7],[0.24,0.666],[0.257,0.661],[0.262,0.634],[0.28,0.629],[0.295,0.597],[0.287,0.572],[0.319,0.542],[0.324,0.54],[0.371,0.517]],"lage-kammern":[[0.386,0.444],[0.37,0.457],[0.351,0.476],[0.335,0.492],[0.319,0.511],[0.303,0.529],[0.29,0.545],[0.274,0.564],[0.261,0.582],[0.247,0.598],[0.237,0.617],[0.221,0.636],[0.207,0.652],[0.194,0.67],[0.178,0.686],[0.165,0.702],[0.152,0.721],[0.136,0.739],[0.125,0.758],[0.112,0.774],[0.098,0.793],[0.082,0.811],[0.072,0.827],[0.059,0.846],[0.048,0.864],[0.035,0.883],[0.021,0.902],[0.013,0.92],[0.003,0.936],[0.0,0.955],[0.008,0.973],[0.019,0.989],[0.029,0.997],[0.043,0.992],[0.051,0.968],[0.064,0.944],[0.072,0.92],[0.085,0.899],[0.096,0.878],[0.109,0.856],[0.12,0.835],[0.133,0.816],[0.146,0.795],[0.16,0.777],[0.17,0.758],[0.184,0.737],[0.197,0.715],[0.21,0.694],[0.226,0.673],[0.239,0.654],[0.253,0.633],[0.266,0.612],[0.279,0.593],[0.295,0.572],[0.311,0.551],[0.327,0.532],[0.34,0.511],[0.356,0.489],[0.372,0.468],[0.388,0.449]],"lage-glasperlen":[[0.314,0.369],[0.303,0.467],[0.274,0.459],[0.274,0.496],[0.274,0.501],[0.245,0.541],[0.232,0.533],[0.211,0.57],[0.214,0.57],[0.187,0.591],[0.174,0.612],[0.177,0.612],[0.148,0.639],[0.153,0.675],[0.129,0.675],[0.137,0.683],[0.103,0.699],[0.1,0.715],[0.079,0.747],[0.069,0.77],[0.053,0.784],[0.024,0.792],[0.032,0.821],[0.011,0.858],[0.021,0.86],[0.011,0.863],[0.008,0.865],[0.003,0.889],[0.016,0.91],[0.032,0.929],[0.042,0.963],[0.04,0.947],[0.045,0.992],[0.074,0.989],[0.066,0.945],[0.103,0.945],[0.098,0.937],[0.103,0.902],[0.124,0.887],[0.127,0.844],[0.132,0.836],[0.135,0.826],[0.153,0.802],[0.156,0.786],[0.182,0.752],[0.195,0.76],[0.195,0.726],[0.211,0.734],[0.224,0.694],[0.222,0.691],[0.219,0.657],[0.248,0.633],[0.298,0.607],[0.298,0.612],[0.282,0.578],[0.343,0.58],[0.322,0.538],[0.34,0.536],[0.354,0.493],[0.372,0.459]],"lage-huelle-unten":[[0.396,0.462],[0.374,0.47],[0.35,0.478],[0.331,0.489],[0.311,0.497],[0.292,0.508],[0.276,0.525],[0.257,0.538],[0.238,0.552],[0.224,0.566],[0.21,0.579],[0.194,0.596],[0.18,0.609],[0.167,0.626],[0.15,0.642],[0.137,0.658],[0.123,0.678],[0.109,0.694],[0.093,0.713],[0.079,0.732],[0.066,0.751],[0.052,0.77],[0.038,0.787],[0.025,0.809],[0.014,0.828],[0.005,0.847],[0.0,0.869],[0.003,0.888],[0.011,0.907],[0.016,0.929],[0.025,0.951],[0.033,0.973],[0.041,0.995],[0.052,0.995],[0.063,0.989],[0.074,0.959],[0.082,0.932],[0.09,0.904],[0.101,0.88],[0.115,0.855],[0.126,0.833],[0.139,0.809],[0.15,0.787],[0.158,0.762],[0.169,0.743],[0.183,0.721],[0.199,0.699],[0.21,0.68],[0.227,0.658],[0.24,0.637],[0.251,0.617],[0.268,0.598],[0.281,0.577],[0.298,0.557],[0.311,0.536],[0.325,0.519],[0.342,0.5],[0.358,0.486],[0.377,0.473],[0.399,0.464]]};

const mq = (q) => (window.matchMedia ? window.matchMedia(q).matches : false);

function initExplorer(root) {
  if (!claim(root, 'Mx')) return;
  let LAYERS = [];
  try { LAYERS = JSON.parse(($('[data-mx-layers]', root) || {}).textContent || '[]'); } catch (e) { LAYERS = []; }
  if (!LAYERS.length) return;
  const total = LAYERS.length, last = total - 1;
  const pad = (n) => String(n).padStart(2, '0');
  const stage = $('.mx-stage', root), stack = $('.mx-stack', root);
  const list = $('.mx-list', root), detail = $('.mx-detail', root);
  const macroImg = $('.mx-macro img', detail), num = $('.mx-num', detail), title = $('.mx-title', detail);
  const text = $('.mx-text', detail), facts = $('.mx-facts', detail);
  const prevB = $('.mx-prev', detail), nextB = $('.mx-next', detail), backB = $('.mx-back', detail);
  const els = [], btns = [];
  let geo = null, state = 'closed', cur = -1, hot = -1;

  // a damped spring as a CSS linear() curve: settles with a small overshoot
  if (window.CSS && CSS.supports && CSS.supports('transition-timing-function', 'linear(0, 1)')) {
    const pts = [], z = 0.72, w0 = 9.5, wd = w0 * Math.sqrt(1 - z * z);
    for (let k = 0; k <= 40; k++) {
      const t = k / 40, v = 1 - Math.exp(-z * w0 * t) * (Math.cos(wd * t) + (z * w0 / wd) * Math.sin(wd * t));
      pts.push((k === 40 ? 1 : v).toFixed(4));
    }
    root.style.setProperty('--mx-ease', 'linear(' + pts.join(', ') + ')');
  }

  LAYERS.forEach((L, i) => {
    const b = document.createElement('div');
    b.className = 'mx-layer'; b.setAttribute('aria-hidden', 'true');
    b.style.setProperty('--w', (L.w * 100) + '%'); b.style.zIndex = String(20 - i);
    b.style.setProperty('--fl', (5.6 + (i % 3) * 0.9) + 's'); b.style.setProperty('--fd', (-i * 0.7) + 's');
    const im = new Image(1400, Math.round(1400 * (L.ratio || 0.27))); im.alt = ''; im.decoding = 'async';
    im.addEventListener('load', layout);
    b.appendChild(im); stack.appendChild(b); els.push(b);
    const li = document.createElement('li'), btn = document.createElement('button');
    btn.type = 'button';
    const bb = document.createElement('b'); bb.textContent = pad(i + 1);
    const sp = document.createElement('span'); sp.textContent = L.title;
    const sm = document.createElement('small'); sm.textContent = L.short; sp.appendChild(sm);
    const ar = document.createElement('i'); ar.setAttribute('aria-hidden', 'true'); ar.textContent = '→';
    btn.append(bb, sp, ar);
    btn.addEventListener('click', () => focusLayer(i, true));
    btn.addEventListener('mouseenter', () => setHot(i));
    btn.addEventListener('mouseleave', () => setHot(-1));
    li.appendChild(btn); list.appendChild(li); btns.push(btn);
  });

  const zoom = () => (geo.SW < 640 ? 1.08 : 1.14);

  let loaded = false;
  function load() {
    if (loaded) return; loaded = true;
    // LIMIT: device pixel ratio counted up to 2, so phones get the 800 px pictures
    const small = stage.clientWidth * Math.min(window.devicePixelRatio || 1, 2) <= 900;
    els.forEach((el, i) => { el.firstChild.src = (small && LAYERS[i].img_sm) || LAYERS[i].img; });
  }
  const ratio = (i) => { const im = els[i].firstChild; return im.naturalWidth ? im.naturalHeight / im.naturalWidth : (LAYERS[i].ratio || 0.27); };

  function layout() {
    const SW = stage.clientWidth, SH = stage.clientHeight;
    if (!SW || !SH) return;
    const h = LAYERS.map((L, i) => L.w * SW * ratio(i));
    const avail = SH * 0.84, sumUp = h.slice(0, last).reduce((a, b) => a + b, 0);
    const q = Math.max(0.34, Math.min(0.78, (avail - h[last]) / Math.max(1, sumUp)));
    let yo = [], y = 0;
    h.forEach((hh) => { yo.push(y); y += q * hh; });
    const tot = yo[last] + h[last], top0 = (SH - tot) / 2 + SH * 0.025;
    yo = yo.map((v) => v + top0);
    const yb = (SH - h[last] * 1.12) / 2, yt = yb + (h[last] - h[0]) - 0.16 * h[last];
    const yc = h.map((hh, i) => (i === 0 ? yt : i === last ? yb : yt + h[0] * 0.5 - hh / 2));
    geo = { SW, SH, h, yo, yc };
    apply();
  }

  function apply(stagger) {
    if (!geo) return;
    const focus = state === 'focus', S = focus ? zoom() : 1, spread = geo.SH * 0.1, mid = last / 2;
    els.forEach((el, i) => {
      let y, o = 1;
      if (state === 'closed') { y = geo.yc[i]; o = (i === 0 || i === last) ? 1 : 0; }
      else { y = geo.yo[i]; }
      if (focus && i !== cur) { y += (i < cur ? -spread : spread); o = 0.14; }
      el.style.setProperty('--y', y.toFixed(1) + 'px');
      el.style.setProperty('--o', o);
      el.style.setProperty('--d', stagger ? (Math.abs(i - mid) * 45) + 'ms' : '0ms');
      el.style.zIndex = String(focus && i === cur ? 30 : 20 - i);
    });
    let ty = 0;
    if (focus) { const c = geo.yo[cur] + geo.h[cur] * 0.55; ty = -S * (c - geo.SH / 2); }
    stack.style.transform = 'translateY(' + ty.toFixed(1) + 'px) scale(' + S + ')';
  }

  function setHot(i) {
    if (hot === i) return;
    if (hot >= 0) { els[hot].classList.remove('is-hot'); btns[hot].classList.remove('is-hot'); }
    hot = i;
    if (i >= 0 && state === 'open') { els[i].classList.add('is-hot'); btns[i].classList.add('is-hot'); }
  }

  function pick(cx, cy) {   // top-most layer whose picture covers the point
    const order = els.map((el, i) => i).sort((a, b) => +els[b].style.zIndex - +els[a].style.zIndex);
    for (const i of order) {
      if (state === 'closed' && i !== 0 && i !== last) continue;
      const r = els[i].getBoundingClientRect(), u = (cx - r.left) / r.width, v = (cy - r.top) / r.height;
      if (u < 0 || u >= 1 || v < 0 || v > 1) continue;
      const map = LAYERS[i].hit && HIT[LAYERS[i].hit];
      if (!map) return i;   // a picture the merchant chose: its whole box counts
      const sp = map[Math.floor(u * 60)];
      if (v >= sp[0] && v <= sp[1]) return i;
    }
    return -1;
  }

  function fill(i) {
    const L = LAYERS[i];
    num.textContent = pad(i + 1) + ' / ' + pad(total);
    title.textContent = L.title; text.textContent = L.text;
    facts.textContent = '';
    (L.facts || []).forEach((f) => { const li = document.createElement('li'); li.textContent = f; facts.appendChild(li); });
    const src = L.nah;
    if (src && macroImg.getAttribute('src') !== src) {
      macroImg.classList.add('is-swap');
      const n = new Image();
      n.onload = () => { macroImg.src = src; macroImg.alt = L.alt || ''; macroImg.classList.remove('is-swap'); };
      n.src = src;
    }
    prevB.disabled = i === 0; nextB.disabled = i === last;
  }

  function focusLayer(i, fromList) {
    if (state === 'closed') return;
    setHot(-1);
    cur = i; state = 'focus'; root.classList.add('is-focus');
    fill(i); apply();
    root.setAttribute('data-layer', String(i + 1));
    if (fromList || document.activeElement === stage) title.focus({ preventScroll: true });
    if (geo && geo.SW < 640) stage.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
  }

  function back() {
    if (state !== 'focus') return;
    const was = cur;
    state = 'open'; cur = -1; root.classList.remove('is-focus'); root.removeAttribute('data-layer');
    apply();
    if (geo && geo.SW < 640) stage.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    if (detail.contains(document.activeElement) || document.activeElement === document.body) btns[was].focus({ preventScroll: true });
  }

  function openUp() {
    if (state !== 'closed') return;
    state = 'open'; apply(true);
    setTimeout(() => root.classList.add('is-ready'), reduce ? 0 : 1100);
  }

  stage.addEventListener('click', (e) => {
    const i = pick(e.clientX, e.clientY);
    if (state === 'closed') { openUp(); return; }
    if (state === 'focus' && (i === cur || i < 0)) { back(); return; }
    if (i >= 0) focusLayer(i, false);
  });
  stage.addEventListener('pointermove', (e) => { if (e.pointerType === 'mouse') setHot(state === 'open' ? pick(e.clientX, e.clientY) : -1); });
  stage.addEventListener('pointerleave', () => setHot(-1));
  stage.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openUp(); focusLayer(cur < 0 ? 0 : cur, true); } });
  prevB.addEventListener('click', () => { if (cur > 0) focusLayer(cur - 1, true); });
  nextB.addEventListener('click', () => { if (cur < last) focusLayer(cur + 1, true); });
  backB.addEventListener('click', back);
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') back();
    if (state === 'focus' && (e.key === 'ArrowDown' || e.key === 'ArrowRight') && cur < last) { e.preventDefault(); focusLayer(cur + 1, true); }
    if (state === 'focus' && (e.key === 'ArrowUp' || e.key === 'ArrowLeft') && cur > 0) { e.preventDefault(); focusLayer(cur - 1, true); }
  });
  let rt = 0;
  onResize(() => { clearTimeout(rt); rt = setTimeout(layout, 120); }, root);

  const hint = $('.mx-hint', root);
  if (hint) hint.textContent = mq('(hover: hover)') ? hint.getAttribute('data-hover') : hint.getAttribute('data-touch');

  root.classList.add('is-init');
  layout();
  requestAnimationFrame(() => root.classList.remove('is-init'));
  if (reduce || !('IntersectionObserver' in window)) { load(); openUp(); return; }
  const pre = new IntersectionObserver((es) => { if (es[0].isIntersecting) { load(); pre.disconnect(); } }, { rootMargin: '700px 0px' });
  pre.observe(stage);
  const io = new IntersectionObserver((es) => {
    es.forEach((en) => { if (en.isIntersecting) { load(); setTimeout(openUp, 250); io.disconnect(); } });
  }, { threshold: 0.35 });
  io.observe(stage);
}

boot((root) => $$('[data-mx]', root).forEach(initExplorer));
